import React, { useCallback, useRef } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { getCurrentSubmission, getVariationTarget } from '../../../../../redux/form/selectors';
import StartingImageButton from '../../lego/StartingImageButton';
import PromptTextArea from '../../lego/PromptTextArea';
import PromptSubmitButton from '../../lego/PromptSubmitButton';
import VariationTag from '../../lego/VariationTag';
import SettingsPanel from '../../../SettingsPanel';
import ErrorArea from '../../lego/ErrorArea';
import { SubmissionStatus } from '../../../../../redux/form/types';
import s from './PromptInputDesktop.scss';
const PromptInputDesktop = ({ formAction, className })=>{
    const variationTarget = useSelector(getVariationTarget);
    const currentSubmission = useSelector(getCurrentSubmission);
    const submitButtonRef = useRef(null);
    const handleKeyDown = useCallback((e)=>{
        if (e.key === 'Enter') {
            if (submitButtonRef.current) {
                submitButtonRef.current.click();
            }
            e.preventDefault();
        }
    }, [
        submitButtonRef
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['input-row'], className)
    }, variationTarget ? /*#__PURE__*/ React.createElement(VariationTag, {
        deviation: variationTarget
    }) : /*#__PURE__*/ React.createElement(StartingImageButton, {
        key: "starting-image"
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text-area-and-error']
    }, /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement(PromptTextArea, {
        formAction: formAction,
        onKeyDown: handleKeyDown
    })), /*#__PURE__*/ React.createElement(ErrorArea, {
        className: c(// Because the error area is always mounted for a11y reasons, we have to make sure the error is actually
        // present before we start adding spacing between it and the text area.
        currentSubmission.status === SubmissionStatus.Error && s['error-area-top-margin'])
    })), /*#__PURE__*/ React.createElement(PromptSubmitButton, {
        formAction: formAction,
        ref: submitButtonRef
    })), /*#__PURE__*/ React.createElement(SettingsPanel, null));
};
PromptInputDesktop.displayName = 'PromptInputFieldWithButton';
export default PromptInputDesktop;

//# sourceMappingURL=PromptInputDesktop.js.map